export const PERSON_FIELD_NAME = {
  name: 'name',
  surname: 'surname',
  patronymic: 'patronymic',
  isPatronymicAbsent: 'isPatronymicAbsent',
  birthdate: 'birthdate',
  deathdate: 'deathdate',
  changeName: 'changeName',
  sex: 'sex',
  birthPlace: 'birthPlace',
};

export const APPLICANT_FIELD_NAME = {
  ...PERSON_FIELD_NAME,
  email: 'email',
  phone: 'phone',
  snils: 'snils',
};

export const CHANGED_FIO_FIELD_NAME = {
  changedName: 'changedName',
  changedSurname: 'changedSurname',
  changedPatronimic: 'changedPatronimic',
};

export const CHANGE_NAME_DOC_ISSUER = 'changeNameDocIssuer';
export const IS_CHANGED_PATRONYMIC_ABSENT = 'isChangedPatronymicAbsent';

export enum MARRIAGE_INFO_FIELD_NAME {
  married = 'married',
  dateOfMarriage = 'dateOfMarriage',
  marriageRecordNumber = 'marriageRecordNumber',
  marriageRecordHolder = 'marriageRecordHolder',
  livingTogether = 'livingTogether',
}

export enum SPOUSE_FIELD_NAME {
  addressMatchWithApplicant = 'addressMatchWithApplicant',
}

export enum AGREEMENTS_FIELD_NAME {
  warnedAboutResponsibility = 'warnedAboutResponsibility',
  consentWithTerms = 'consentWithTerms',
  centerPGU = 'centerPGU',
  needPaperCertificate = 'needPaperCertificate',
}

export const CHILD_FIELD_NAME = {
  bornInNotCurrentMarriage: 'bornInNotCurrentMarriage',
  bornInCurrentMarriage: 'bornInCurrentMarriage',
};

export enum SECOND_PARENT_FIELD_NAME {
  proofOfDeath = 'proofOfDeath',
  status = 'status',
  dateOfMarriage = 'dateOfMarriage',
  dateOfDivorce = 'dateOfDivorce',
  divorceDocIssuer = 'divorceDocIssuer',
  deathDocIssuer = 'deathDocIssuer',
}

export enum ORGANIZATION_FIELD_NAME {
  institutionName = 'institutionName',
  isFoundInCatalog = 'isFoundInCatalog',
}

export const EMPTY_PATRONYMIC_LABEL = {
  patronymic: 'emptyPatronymic',
  changedPatronimic: 'emptyChangedPatronymic',
};

export const IS_EMPTY_PATRONYMIC_FIELD_NAME = {
  [EMPTY_PATRONYMIC_LABEL.patronymic]: PERSON_FIELD_NAME.isPatronymicAbsent,
  [EMPTY_PATRONYMIC_LABEL.changedPatronimic]: IS_CHANGED_PATRONYMIC_ABSENT,
};

export const PATRONYMIC_FIELD_NAME = {
  [EMPTY_PATRONYMIC_LABEL.patronymic]: PERSON_FIELD_NAME.patronymic,
  [EMPTY_PATRONYMIC_LABEL.changedPatronimic]:
    CHANGED_FIO_FIELD_NAME.changedPatronimic,
};

export const FIO_FIELDS = [
  PERSON_FIELD_NAME.name,
  PERSON_FIELD_NAME.surname,
  PERSON_FIELD_NAME.patronymic,
  ...Object.values(CHANGED_FIO_FIELD_NAME),
  CHANGE_NAME_DOC_ISSUER,
];

export const DOCUMENT_FIELD_NAME = {
  issuer: 'issuer',
  issueDate: 'issueDate',
  type: 'type',
  number: 'number',
  divisionCode: 'divisionCode',
};
